export const CHECKBOX_LABELS = [
    "Brainstorming topic",
    "Objective 1",
    "Objective 2",
    "Prior Ideas",
    "Prior Evaluations",
    "Context",
];
// Domain and example problem definitions for Sidebar dropdowns
export const EXAMPLE_PROBLEMS = {
    "General Public": {
        "Travel & Vacations": {
            question: "Where should we go on vacation this year?",
            objective1: "Experience value (activities, uniqueness)",
            objective2: "Budget / travel effort",
        },
        "Hobbies & Free Time": {
            question: "What hobby should I pick up next?",
            objective1: "Personal enjoyment / interest",
            objective2: "Time and cost to get started",
        },
        "Health & Lifestyle": {
            question: "What kind of workout should I focus on?",
            objective1: "Health benefits / results",
            objective2: "Enjoyment / consistency",
        },
    },
    Banking: {
        "Credit Risk Strategy": {
            question: "Which customer segments should we prioritize for lending growth?",
            objective1: "Risk exposure (default probability, portfolio stability)",
            objective2: "Revenue potential (interest income, lifetime value)",
        },
        "Fraud Detection Investment": {
            question: "Where should we invest to reduce fraud most effectively?",
            objective1: "Fraud reduction impact",
            objective2: "Customer friction (false positives, UX impact)",
        },
        "Digital Feature Rollout": {
            question: "Which digital banking features should we launch next?",
            objective1: "Customer adoption / engagement",
            objective2: "Implementation complexity",
        },
    },
    Retail: {
        "Assortment Optimization": {
            question: "Which products should we prioritize in inventory?",
            objective1: "Sales velocity / demand",
            objective2: "Margin contribution",
        },
        "Pricing Strategy": {
            question: "Where should we adjust pricing to maximize performance?",
            objective1: "Revenue / profit uplift",
            objective2: "Price sensitivity / customer perception",
        },
        "Personalization Strategy": {
            question: "Which personalization use cases should we invest in first?",
            objective1: "Conversion / basket size impact",
            objective2: "Data readiness / implementation effort",
        },
    },
    Healthcare: {
        "Clinical Trial Prioritization": {
            question: "Which trials should we prioritize for funding and acceleration?",
            objective1: "Patient impact / unmet need",
            objective2: "Probability of success",
        },
        "Patient Intervention Strategy": {
            question: "Which patient populations should we target for intervention programs?",
            objective1: "Health outcome improvement",
            objective2: "Cost of intervention",
        },
        "R&D Portfolio Optimization": {
            question: "Which drug candidates should we advance in the pipeline?",
            objective1: "Clinical efficacy potential",
            objective2: "Time and cost to market",
        },
    },
    "Product Design and Development": {
        "Product roadmap prioritization": {
            question: "Which initiatives should we prioritize this quarter?",
            objective1: "Customer impact",
            objective2: "Engineering effort",
        },
        "Pricing strategy": {
            question: "How should we price this product?",
            objective1: "Revenue",
            objective2: "Market adoption",
        },
        "Market entry strategy": {
            question: "Which market should we enter next?",
            objective1: "Market size",
            objective2: "Time to launch",
        },
    },
};
export const COGNIZANT_AI_LAB_URL = "https://www.cognizant.com/us/en/ai-lab";
export const COGNIZANT_URL = "https://www.cognizant.com/us/en";
export const LMX_PAPER_URL = "https://arxiv.org/abs/2302.12170";
export const NEURO_SAN_URL = "https://github.com/cognizant-ai-lab/neuro-san-studio";
